import { animate, state, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { Component, computed, effect, inject, input, signal } from '@angular/core';
import {
  CardBodyComponent,
  CardComponent,
  GroundworksTableComponent,
} from '@groundworks/ngx-groundworks-ui';
import { QuoteInfo } from '../../sdk/sdk';
import { QuoteTableBuilderService } from '../../services/quote-table-builder.service';
import { FinancingSummaryComponent } from '../financing-summary/financing-summary.component';

@Component({
  selector: 'app-quote-viewer',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    GroundworksTableComponent,
    FinancingSummaryComponent,
  ],
  templateUrl: './quote-viewer.component.html',
  animations: [
    trigger('expandCollapse', [
      state(
        'expanded',
        style({
          height: '*',
          opacity: 1,
        })
      ),
      state(
        'collapsed',
        style({
          height: '0',
          opacity: 0,
          overflow: 'hidden',
        })
      ),
      transition('expanded <=> collapsed', animate('300ms ease-in-out')),
    ]),
    trigger('rotateArrow', [
      state(
        'expanded',
        style({
          transform: 'rotate(90deg)',
        })
      ),
      state(
        'collapsed',
        style({
          transform: 'rotate(0deg)',
        })
      ),
      transition('expanded <=> collapsed', animate('300ms ease-in-out')),
    ]),
  ],
})
export class QuoteViewerComponent {
  private readonly tableBuilder = inject(QuoteTableBuilderService);

  readonly quote = input<QuoteInfo>(new QuoteInfo());
  readonly initiallyExpanded = input<boolean>(false);
  readonly isLoadingInput = input<boolean>(false);
  readonly hasErrorInput = input<boolean>(false);

  isExpanded = signal(false);

  readonly tableData = computed(() => this.tableBuilder.buildTableData(this.quote()));

  constructor() {
    effect(() => {
      this.isExpanded.set(this.initiallyExpanded());
    });
  }

  toggleCollapse() {
    this.isExpanded.set(!this.isExpanded());
  }
}
